module.exports = __webpack_public_path__ + "static/media/20_B.55504181.png";